import { useCallback } from 'react';
import useNotification from './useNotification';

const useErrorHandling = (navigate = false) => {
    const { showNotification } = useNotification();

    const handleError = useCallback((error, fallbackMessage = 'Ocorreu um erro') => {
        console.log('Erro no handleError:', error); // Log para debug
        let message = fallbackMessage;

        // Tenta pegar a mensagem e detalhes de erro na estrutura direta do objeto (se existir)
        if (error?.message && error?.data && typeof error.data === 'object') {
            message = error.message;
            const detailedMessages = Object.values(error.data).flat();
            message += ': ' + detailedMessages.join(', ');
        }
        // Caso clássico axios/fetch com response.data
        else if (error?.response?.data) {
            if (typeof error.response.data === 'string') {
                message = error.response.data;
            } else if (typeof error.response.data.message === 'string') {
                message = error.response.data.message;
            }
            if (error.response.data.data && typeof error.response.data.data === 'object') {
                const detailedMessages = Object.values(error.response.data.data).flat();
                message += ': ' + detailedMessages.join(', ');
            }
        }
        // Se erro tem só message string
        else if (typeof error?.message === 'string') {
            message = error.message;
        }
        // Se erro é string
        else if (typeof error === 'string') {
            message = error;
        }
        // Caso genérico: tenta converter em string
        else {
            try {
                message = JSON.stringify(error);
            } catch {
                message = fallbackMessage;
            }
        }

        if (!(error?.status === 404 || error?.response?.status === 404)) {
            showNotification('error', message);
        }

        if ((error?.status === 404 || error?.response?.status === 404) && navigate) {
            navigate('/dashboard');
        }
    }, [navigate, showNotification]);

    return { handleError };
};

export default useErrorHandling;
